/* tslint:disable */

declare var Object: any;
export interface ClientVersionInterface {
  "name": string;
  "version": string;
  "id"?: any;
}

export class ClientVersion implements ClientVersionInterface {
  "name": string;
  "version": string;
  "id": any;
  constructor(data?: ClientVersionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ClientVersion`.
   */
  public static getModelName() {
    return "ClientVersion";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ClientVersion for dynamic purposes.
  **/
  public static factory(data: ClientVersionInterface): ClientVersion{
    return new ClientVersion(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ClientVersion',
      plural: 'ClientVersions',
      path: 'ClientVersions',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "version": {
          name: 'version',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
